import { useEffect, useState } from "react";
import { Route, useHistory } from "react-router";
import Utils from "../../lib/Utils";

const PrivateRoute = ({ path, children }) => {

    const history = useHistory();
    const [loggedIn, setLoggedIn] = useState(false);
    
    useEffect(() => {
        if(!Utils.CheckUser()){
            history.push('/');
        } else {
            setLoggedIn(true);
        }
    }, []);

    return loggedIn ? <Route path={path}>{children}</Route> : <></>
}

export { PrivateRoute };